/**
 * WalkAndPunch API
 * This is the WalkAndPunch Service API.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ConfiguredReportViewModel } from '../model/configuredReportViewModel';
import { ConfiguredReportViewModelDataSourceResult } from '../model/configuredReportViewModelDataSourceResult';
import { ExternalReportUserBody } from '../model/externalReportUserBody';
import { ExternalReportUserBody1 } from '../model/externalReportUserBody1';
import { ExternalReportUserBody2 } from '../model/externalReportUserBody2';
import { ExternalReportUserBody3 } from '../model/externalReportUserBody3';
import { ProblemDetails } from '../model/problemDetails';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ExternalReportService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param reportId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProjectReport(reportId: number, observe?: 'body', reportProgress?: boolean): Observable<ConfiguredReportViewModel>;
    public getProjectReport(reportId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ConfiguredReportViewModel>>;
    public getProjectReport(reportId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ConfiguredReportViewModel>>;
    public getProjectReport(reportId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (reportId === null || reportId === undefined) {
            throw new Error('Required parameter reportId was null or undefined when calling getProjectReport.');
        }

        let headers = this.defaultHeaders;

        // authentication (oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ConfiguredReportViewModel>('get',`${this.basePath}/v1/ExternalReport/${encodeURIComponent(String(reportId))}/View`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUserProjectReports(body?: ExternalReportUserBody, observe?: 'body', reportProgress?: boolean): Observable<ConfiguredReportViewModelDataSourceResult>;
    public getUserProjectReports(body?: ExternalReportUserBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ConfiguredReportViewModelDataSourceResult>>;
    public getUserProjectReports(body?: ExternalReportUserBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ConfiguredReportViewModelDataSourceResult>>;
    public getUserProjectReports(body?: ExternalReportUserBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ConfiguredReportViewModelDataSourceResult>('post',`${this.basePath}/v1/ExternalReport/User`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
